export const datHang = {
  sections: {
    list: { title: 'Đặt hàng' },
    detail: { title: 'Chi tiết đặt hàng' },
  },
  lineList: {
    title: 'Đặt hàng chi tiết hàng',
    tabOrders: 'Đặt hàng',
    tabLines: 'Chi tiết hàng',
    summary: 'Tổng {count} dòng hàng',
    noData: 'Không có dữ liệu',
    columns: {
      maDatHang: 'Mã đặt hàng',
      thoiGian: 'Thời gian đặt',
      trangThai: 'Trạng thái',
      chiNhanh: 'Chi nhánh',
      nguoiBan: 'Người bán',
      maKhachHang: 'Mã KH',
      tenKhachHang: 'Tên khách hàng',
      maHangHoa: 'Mã hàng',
      tenHangHoa: 'Tên hàng',
      donViTinh: 'ĐVT',
      soLuong: 'Số lượng',
      soLuongDaXuat: 'SL đã xuất',
      tongCanNang: 'Số cân (kg)',
      tongTheTich: 'Số khối (m³)',
      donGia: 'Đơn giá',
      giamGia: 'Giảm giá dòng',
      giaBan: 'Giá bán',
      thanhTien: 'Thành tiền',
      giamGiaChung: 'Giảm giá chung',
      thuKhacChung: 'Thu khác',
      tongCong: 'Tổng cộng',
      ghiChu: 'Ghi chú',
    },
  },
  titles: { add: 'Đặt hàng' },
  columns: {
    code: 'Mã',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
  },
  filter: { searchPlaceholder: 'Tìm theo mã đặt hàng...' },
  filters: {
    all: 'Tất cả',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRange: 'Khoảng thời gian',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    status: 'Trạng thái',
    statusSection: 'Trạng thái đặt hàng',
    dateSection: 'Thời gian đặt',
    salesSection: 'Bán hàng',
    peopleSection: 'Người dùng',
    receiver: 'Người nhận đặt',
    deliverySection: 'Giao hàng',
    deliveryPartner: 'Đối tác giao hàng',
    deliveryArea: 'Khu vực giao hàng',
    favoriteSection: 'Yêu thích',
    textDetailTitle: 'Bộ lọc đặt hàng',
    khachHangPlaceholder: 'Tìm khách hàng',
    locChung: 'Lọc chung',
    maDonHang: 'Theo mã',
    maNhanVien: 'Mã nhân viên',
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    diaChiNhanHang: 'Địa chỉ nhận hàng',
    diaChiGiaoHang: 'Địa chỉ giao hàng',
    sortField: 'Sắp xếp theo',
    sortDir: 'Thứ tự',
    sortThoiGian: 'Thời gian đặt',
    sortMaDonHang: 'Mã đặt hàng',
    sortKhachCanTra: 'Khách cần trả',
    sortTongTienHang: 'Tổng tiền hàng',
  },
  form: {
    code: 'Mã đặt hàng',
    codeAuto: 'Để trống tự sinh mã',
    customer: 'Khách hàng',
    retailCustomer: 'Khách lẻ',
    congNoHienTai: 'Công nợ',
    congNoKhachNo: 'Khách nợ',
    congNoNoKhach: 'Nợ khách',
    channel: 'Kênh bán',
    discount: 'Giảm giá (đ)',
    discountShort: 'Giảm giá',
    salePrice: 'Giá bán',
    bangGiaDefault: 'Bảng giá chung',
    discountPercent: 'Giảm (%)',
    otherIncome: 'Thu khác',
    note: 'Ghi chú',
    lines: 'Chi tiết hàng',
    danhSachChiTiet: 'Danh sách chi tiết',
    addLine: 'Thêm dòng',
    product: 'Hàng hóa',
    maHang: 'Mã hàng',
    productName: 'Tên hàng',
    productSearch: 'Tìm mã / tên hàng',
    qty: 'Số lượng',
    unitPrice: 'Đơn giá',
    lineNote: 'Ghi chú dòng',
    lineAmount: 'Thành tiền',
    deliverySection: 'Thông tin giao hàng',
    paymentSection: 'Thanh toán',
    addPayment: 'Thêm khoản thanh toán',
    removePayment: 'Xóa',
    paymentAmount: 'Số tiền',
    tabGeneral: 'Thông tin chung',
    tabLines: 'Chi tiết hàng hóa',
    tabDelivery: 'Giao hàng',
    tabPayment: 'Thanh toán',
  },
  messages: {
    loadError: 'Không tải được danh sách đặt hàng.',
    deleteSuccess: 'Đã xóa đặt hàng.',
    createSuccess: 'Đã tạo đặt hàng.',
    updateSuccess: 'Đã cập nhật đặt hàng.',
    needLines: 'Vui lòng thêm ít nhất một dòng hàng.',
    needKhachHang: 'Vui lòng chọn khách hàng.',
    validateThoiGianGiaoBeforeThoiGian:
      'Thời gian giao hàng không được trước thời gian tạo đơn/hóa đơn.',
    warnStockCost: 'Cảnh báo tồn/giá vốn: {detail}',
    noData: 'Không có đặt hàng.',
    noLines: 'Không có dòng hàng.',
    listSummary: 'Tổng {count} đặt hàng',
    confirmDelete: 'Xóa đặt hàng {name}?',
    copySuccess: 'Đã sao chép đặt hàng.',
    favoriteSuccess: 'Đã cập nhật yêu thích.',
    statusSuccess: 'Đã cập nhật trạng thái đặt hàng.',
    confirmKetThuc:
      'Kết thúc đặt hàng {name}? Trạng thái sẽ được cập nhật thành Hoàn thành.',
    confirmKetThucSelected:
      'Kết thúc {count} đặt hàng đã chọn? Trạng thái sẽ được cập nhật thành Hoàn thành. Các đơn đã hủy / hoàn thành / đã chốt sẽ được bỏ qua.',
    confirmHuy:
      'Hủy đặt hàng {name}? Trạng thái sẽ được cập nhật thành Đã hủy.',
    confirmHuySelected:
      'Hủy {count} đặt hàng đã chọn? Trạng thái sẽ được cập nhật thành Đã hủy. Các đơn đã hủy / hoàn thành / đã chốt sẽ được bỏ qua.',
    huySelectedSuccess: 'Đã hủy {ok}/{total} đặt hàng.',
    huySelectedPartial: 'Đã hủy {ok}/{total} đặt hàng. {fail} đơn lỗi / không hủy được.',
    huySelectedNone: 'Không có đặt hàng nào trong lựa chọn có thể hủy.',
    ketThucSelectedSuccess: 'Đã kết thúc {ok}/{total} đặt hàng.',
    ketThucSelectedPartial: 'Đã kết thúc {ok}/{total} đặt hàng. {fail} đơn lỗi / không kết thúc được.',
    ketThucSelectedNone: 'Không có đặt hàng nào trong lựa chọn có thể kết thúc.',
    chotSuccess: 'Đã chốt đặt hàng thành hóa đơn.',
    chotConfirm: 'Đặt hàng sẽ được chốt thành hóa đơn với mã HD mới. Tiếp tục?',
    importSuccess: 'Nhập đặt hàng thành công.',
    importDescription:
      'Chọn file Excel theo mẫu để nhập đặt hàng (phiếu tạm). Thời gian / người bán trống → dùng hiện tại / tài khoản đang đăng nhập. Kênh bán mặc định Tự giao.',
    importWillCreate: 'Sẽ tạo {count} đặt hàng từ file đã chọn.',
    importPreviewProgress: 'Xem trước {current}/{total}',
    importPreviewStopped: 'Đã dừng xem trước.',
    importPreviewDone: 'Đã xem trước xong {done}/{total} đặt hàng.',
    importPreviewLoading: 'Đang chuẩn bị đặt hàng {current}/{total}…',
  },
  actions: {
    copy: 'Sao chép',
    favorite: 'Yêu thích',
    changeStatus: 'Đổi trạng thái',
    chotThanhHoaDon: 'Chốt thành hóa đơn',
    datHang: 'Đặt hàng',
    thayDoiDatHang: 'Thay đổi đặt hàng',
    taoHoaDon: 'Tạo hóa đơn',
    xuatHoaDon: 'Xuất hóa đơn',
    xuatHoaDonMoi: 'Xuất hóa đơn mới',
    ketThuc: 'Kết thúc',
    ketThucSelected: 'Kết thúc ({count})',
    ketThucMenu: 'Kết thúc',
    printSelected: 'In đơn ({count})',
    printMenu: 'In đơn',
    huySelected: 'Hủy ({count})',
    huyMenu: 'Hủy',
    bulkSelected: 'Thao tác ({count})',
    dongY: 'Đồng ý',
    xuLyDonHang: 'Xử lý đơn hàng',
    print: 'In',
    exportFile: 'Xuất file',
    dieuChinhCot: 'Điều chỉnh cột',
    huyBo: 'Hủy',
  },
  fields: {
    maDatHang: 'Mã đặt hàng',
    maKhachHang: 'Mã khách hàng',
    nhanVienPhuTrach: 'NVKD phụ trách khách',
    soSanPham: 'Tổng số sản phẩm',
    soLuongSanPham: 'Tổng số lượng SP',
    tongCanNang: 'Tổng số cân (kg)',
    tongTheTich: 'Tổng số khối (m³)',
    maHoaDon: 'Mã hóa đơn',
    nguoiTao: 'Người tạo đơn',
    nguoiTaoHeThong: 'Hệ thống',
    nguoiBan: 'Người bán',
    nguoiNhanDat: 'Người nhận đặt',
    tenKhachHang: 'Tên khách hàng',
    khachHang: 'Khách hàng',
    kenhBan: 'Kênh bán',
    ngayDatHang: 'Thời gian đặt',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    thoiGian: 'Thời gian đặt',
    bangGia: 'Bảng giá',
    trangThai: 'Trạng thái',
    hinhThucGiao: 'Hình thức giao',
    diaChiLayHang: 'Địa chỉ lấy hàng',
    savedAddress: 'Thông tin giao hàng đã lưu',
    savedAddressPlaceholder: 'Chọn thông tin giao hàng',
    savedAddressEmpty: 'Chưa có thông tin giao hàng nào đã lưu',
    nguoiNhan: 'Người nhận',
    dienThoai: 'Điện thoại',
    diaChi: 'Địa chỉ',
    khuVuc: 'Khu vực',
    phuongXa: 'Phường xã',
    soKien: 'Số kiện',
    trongLuong: 'Trọng lượng',
    donViTrongLuong: 'Đơn vị trọng lượng',
    kichThuoc: 'Kích thước',
    chieuDai: 'Chiều dài',
    chieuRong: 'Chiều rộng',
    chieuCao: 'Chiều cao',
    donViKichThuoc: 'Đơn vị kích thước',
    dichVu: 'Dịch vụ',
    nguoiGiaoDoiTac: 'Người giao',
    doiTacGiaoHang: 'Đối tác giao hàng',
    thuHoTien: 'Thu hộ tiền (COD)',
    thuHoTienShort: 'Thu hộ tiền',
    soTienCod: 'Số tiền COD',
    phiTraDTGH: 'Phí trả ĐTGH',
    thoiGianGiaoHang: 'Hạn giao hàng',
    ghiChuGiaoHang: 'Ghi chú giao',
    ghiChuChoBuuta: 'Ghi chú cho bưu tá',
    tongTienHang: 'Tổng tiền hàng',
    giamGia: 'Giảm giá',
    thuKhac: 'Thu khác',
    khachCanTra: 'Khách cần trả',
    khachDaTra: 'Khách đã trả',
    giamGiaHoaDon: 'Giảm giá hóa đơn',
    phiShip: 'Phí ship',
    chiNhanh: 'Chi nhánh',
    chiNhanhXuLy: 'Chi nhánh xử lý',
    chiNhanhTao: 'Chi nhánh tạo',
    ghiChu: 'Ghi chú đặt hàng',
    maVanDon: 'Mã vận đơn',
    totalAmount: 'Tổng tiền',
    paymentMethod: 'Phương thức thanh toán',
    yeuThich: 'Yêu thích',
    actions: 'TT',
  },
  paymentMethod: {
    TIEN_MAT: 'Tiền mặt',
    THE: 'Thẻ',
    VI: 'Ví',
    CHUYEN_KHOAN: 'Chuyển khoản',
    DIEM: 'Điểm thưởng',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
    toggleStar: 'Đánh dấu yêu thích',
    selectAllPage: 'Chọn tất cả hàng trên trang này',
    selectRow: 'Chọn hàng',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietDonHang: 'Chi tiết đơn hàng',
  },
  summary: {
    tongTienHangCount: 'Tổng tiền hàng ({count})',
    tongSoLuong: 'Tổng số lượng',
    tongTienHang: 'Tổng tiền hàng',
    giamGiaPhieuDat: 'Giảm giá phiếu đặt',
    tongCong: 'Tổng cộng',
    hangSuaChua: 'Hàng sửa chữa',
  },
  status: {
    PHIEU_TAM: 'Phiếu tạm',
    DANG_XU_LY: 'Đang xử lý',
    DANG_GIAO_HANG: 'Đang giao hàng',
    HOAN_THANH: 'Hoàn thành',
    KHONG_GIAO_DUOC: 'Không giao được',
    DA_HUY: 'Đã hủy',
  },
  placeholders: {
    formTitle: 'Tạo / sửa đặt hàng',
    formBody:
      'Biểu mẫu đầy đủ (khách, hàng, thanh toán, giao hàng) sẽ được bổ sung theo nghiệp vụ. Hiện có thể xem danh sách và chi tiết từ API.',
    ghiChu: 'Ghi chú...',
    ghiChuGiao: 'Ghi chú giao...',
    chonDoiTac: 'Chọn đối tác...',
  },
  xuatHoaDon: {
    // Section / modal
    sectionTitle: 'Xuất hóa đơn',
    tienDoTitle: 'Tiến độ xuất hóa đơn',
    chiTietTungDong: 'Chi tiết theo dòng',
    danhSachHoaDonCon: 'Danh sách hóa đơn con',
    xuatHoaDonMoi: 'Xuất hóa đơn mới',
    // Modal
    modalTitle: 'Tạo hóa đơn con',
    modalSubtitle: 'Chọn dòng và số lượng cần xuất sang hóa đơn con.',
    submit: 'Tạo hóa đơn',
    ghiChuHoaDon: 'Ghi chú hóa đơn con',
    ghiChuPlaceholder: 'Ghi chú nội bộ cho lần xuất này',
    needSelect: 'Vui lòng nhập số lượng cho ít nhất 1 dòng.',
    overQty: 'Số lượng xuất vượt quá còn lại của hàng {ma} (chỉ còn {conLai}).',
    createSuccess: 'Đã tạo hóa đơn con {ma}.',
    noLinesAvailable: 'Không còn dòng nào có thể xuất hóa đơn (đã xuất hết hoặc đặt hàng rỗng).',
    noLines: 'Không có dòng hàng.',
    chuaCoHoaDonCon: 'Đặt hàng này chưa xuất hóa đơn con nào.',
    // Cột
    colConLai: 'Còn lại',
    colXuat: 'Xuất',
    // Summary
    summary: 'Đã xuất {daXuat}/{tong} (còn {conLai})',
    soHang: '{daHet}/{tong} dòng đã xuất hết',
    soHoaDonCon: '{count} hóa đơn con',
    totalSelected: 'Số dòng đã chọn',
    totalQty: 'Tổng SL xuất',
  },
  pos: {
    addTab: 'Thêm tab đặt hàng',
    history: 'Lịch sử',
    tabTitle: 'Đặt hàng {n}',
    tabEdit: 'Sửa {code}',
    tabClone: 'Nhái {code}',
    newTabDatHang: 'Đặt hàng mới',
    confirmCloseTitle: 'Đóng tab này?',
    confirmCloseBody: 'Tab có thay đổi chưa lưu. Đóng tab sẽ mất các thay đổi chưa lưu.',
  },
}
